import React from "react"
import { withRouter } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"

import RadioYesNo from "./RadioYesNo"
import { Config } from "../Auth"
import SaveModal from "./SaveModal"
import ApplicationActions from "./ApplicationActions"

import {
  Grid,
  Dropdown,
  Segment,
  Container,
  Form,
  Message,
  Header,
  Label
} from "semantic-ui-react"
import TopMessage from "./TopMessage"
import ApplicationBullets from "./ApplicationBullets"
import CommandPositions from "./CommandPositions"
import Positions from "./Positions"

class ApplicationForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      isFinal: false,
      working: false,
      formTouched: false,
      dataIsLoading: true,
      submitModalIsOpen: false,
      perifereies: [],
      logoiMetathesis: [],
      theseisExoterikou: [],
      theseisEythinis: [],
      onlyAbroad: false,
      application: { epithymiesExoterikou: [] },
      errors: {
        // a: false,
        // b: false,
        // c: false,
        agreeWithTerms: false
      },
      errorMessages: []
    }
  }

  componentDidMount() {
    if (this.props.user.access_token) {
      axios
        .get(Config.checkApi, {
          headers: {
            Authorization: `Bearer ${this.props.user.access_token}`
          }
        })
        .then((res) => {
          if (!res.data.working || res.data.isFinal) {
            this.props.history.push("/report")
          }
          this.setState({
            isFinal: res.data.isFinal,
            working: res.data.working
          })
        })
        .catch((error) => {
          toast.error("Αποτυχία μεταφοράς δεδομένων", {
            position: "bottom-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          })
        })
      axios
        .get(Config.dataApi, {
          headers: {
            Authorization: `Bearer ${this.props.user.access_token}`
          }
        })
        .then((res) => {
          this.setState({
            perifereies: res.data.perifereies,
            logoiMetathesis: res.data.logoiMetathesis,
            theseisExoterikou: res.data.theseisExoterikou,
            theseisEythinis: res.data.theseisEythinis,
            application: res.data.application,
            onlyAbroad: res.data.onlyAbroad,
            dataIsLoading: false
          })
        })
        .catch((error) => {
          this.setState({
            dataIsLoading: false
          })
          toast.error("Αποτυχία μεταφοράς δεδομένων", {
            position: "bottom-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          })
        })
    }
  }

  saveApplication = () => {
    this.setState({
      dataIsLoading: true
    })
    axios
      .post(Config.dataApi, this.state.application, {
        headers: {
          Authorization: `Bearer ${this.props.user.access_token}`
        }
      })
      .then((response) => {
        if (response.data.isFinal !== true) {
          this.setState({
            errorMessages: [],
            //errors: { a: false, b: false, c: false, agreeWithTerms: false },
            errors: { agreeWithTerms: false },
            formTouched: false,
            application: response.data,
            dataIsLoading: false
          })
          toast.info("Επιτυχής αποθήκευση", {
            position: "bottom-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          })
        } else {
          this.props.history.push("/report")
        }
      })
      .catch((error) => {
        this.setState((prevState) => ({
          dataIsLoading: false,
          application: {
            ...prevState.application,
            isFinal: false
          }
        }))
        toast.error(
          "Αποτυχία κατά την αποθήκευση. " + error.response.data.Message,
          {
            position: "bottom-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          }
        )
      })
  }

  finalSave = () => {
    this.setState(
      (prevState) => ({
        submitModalIsOpen: false,
        errorMessages: [],
        //errors: { a: false, b: false, c: false, agreeWithTerms: false },
        errors: { agreeWithTerms: false },
        formTouched: false,
        application: {
          ...prevState.application,
          isFinal: true
        }
      }),
      this.saveApplication
    )
  }

  toggleSubmitModal = () => {
    this.setState((prevState) => ({
      submitModalIsOpen: !prevState.submitModalIsOpen
    }))
  }

  clearValues = (choice) => {
    this.setState((prevState) => ({
      errorMessages: [],
      //errors: { a: false, b: false, c: false, agreeWithTerms: false },
      errors: { agreeWithTerms: false },
      formTouched: true,
      application: {
        ...prevState.application,
        ["selectedPerifereia" + choice]: null,
        ["selectedDimos" + choice]: null,
        ["selectedLogos" + choice]: null
      }
    }))
  }

  handleDataChange = (event, { name, value, type, checked }) => {
    if (type === "checkbox") {
      value = checked
    }

    if (name === "anafora" && value === false) {
      this.setState((prevState) => ({
        errorMessages: [],
        //errors: { a: false, b: false, c: false, agreeWithTerms: false },
        errors: { agreeWithTerms: false },
        formTouched: true,
        application: {
          ...prevState.application,
          logosAnaforas: "",
          [name]: value
        }
      }))
    } else {
      this.setState((prevState) => ({
        errorMessages: [],
        //errors: { a: false, b: false, c: false, agreeWithTerms: false },
        errors: { agreeWithTerms: false },
        formTouched: true,
        application: {
          ...prevState.application,
          [name]: value
        }
      }))
    }
  }

  handleChange = (name, value) => {
    if (name === "epithymiaMetathesis" && value === false) {
      this.setState((prevState) => ({
        errorMessages: [],
        //errors: { a: false, b: false, c: false, agreeWithTerms: false },
        errors: { agreeWithTerms: false },
        formTouched: true,
        application: {
          ...prevState.application,
          epithymiaMetathesis: false,
          epithymiaDietias: false,
          selectedPerifereiaA: null,
          selectedDimosA: null,
          selectedLogosA: null,
          selectedPerifereiaB: null,
          selectedDimosB: null,
          selectedLogosB: null,
          selectedPerifereiaC: null,
          selectedDimosC: null,
          selectedLogosC: null,
          epithymiesExoterikou: [],
          thesiEythinisA: null,
          thesiEythinisB: null,
          thesiEythinisC: null,
          agreeWithTerms: false
        }
      }))
    } else {
      this.setState((prevState) => ({
        errorMessages: [],
        //errors: { a: false, b: false, c: false, agreeWithTerms: false },
        errors: { agreeWithTerms: false },
        formTouched: true,
        application: { ...prevState.application, [name]: value }
      }))
    }
  }

  validateForm = () => {
    let newErrorMessages = []
    //let newErrors = { a: false, b: false, c: false, agreeWithTerms: false }
    let newErrors = { agreeWithTerms: false }

    // if (this.state.application.epithymiaMetathesis) {
    //   //first choice is empty
    //   if (
    //     !this.state.application.selectedPerifereiaA &&
    //     !this.state.application.selectedDimosA &&
    //     !this.state.application.selectedLogosA
    //   ) {
    //     newErrorMessages.push(
    //       "Εφόσον επιθυμείτε μετάθεση, θα πρέπει να συμπληρώσετε τουλάχιστον την επιλογή Α"
    //     )
    //     newErrors.a = true
    //   }
    //   //for the three choises check if all of the fields exist
    //   if (
    //     (this.state.application.selectedPerifereiaA ||
    //       this.state.application.selectedDimosA ||
    //       this.state.application.selectedLogosA) &&
    //     !(
    //       this.state.application.selectedPerifereiaA &&
    //       this.state.application.selectedDimosA &&
    //       this.state.application.selectedLogosA
    //     )
    //   ) {
    //     newErrorMessages.push(
    //       "Πρέπει να συμπληρώσετε και τα τρία πεδία στην επιλογή Α επιθυμιών μετάθεσης"
    //     )
    //     newErrors.a = true
    //   }
    //   if (
    //     (this.state.application.selectedPerifereiaB ||
    //       this.state.application.selectedDimosB ||
    //       this.state.application.selectedLogosB) &&
    //     !(
    //       this.state.application.selectedPerifereiaB &&
    //       this.state.application.selectedDimosB &&
    //       this.state.application.selectedLogosB
    //     )
    //   ) {
    //     newErrorMessages.push(
    //       "Πρέπει να συμπληρώσετε και τα τρία πεδία στην επιλογή Β επιθυμιών μετάθεσης"
    //     )
    //     newErrors.b = true
    //   }
    //   if (
    //     (this.state.application.selectedPerifereiaC ||
    //       this.state.application.selectedDimosC ||
    //       this.state.application.selectedLogosC) &&
    //     !(
    //       this.state.application.selectedPerifereiaC &&
    //       this.state.application.selectedDimosC &&
    //       this.state.application.selectedLogosC
    //     )
    //   ) {
    //     newErrorMessages.push(
    //       "Πρέπει να συμπληρώσετε και τα τρία πεδία στην επιλογή Γ επιθυμιών μετάθεσης"
    //     )
    //     newErrors.c = true
    //   }
    // }

    // if (
    //   this.state.onlyAbroad &&
    //   this.state.application.epithymiesExoterikou.length === 0
    // ) {
    //   newErrorMessages.push(
    //     "Πρέπει να επιλέξετε τουλάχιστον μία θέση εξωτερικού"
    //   )
    //   newErrors.theseisExoterikou = true
    // }

    if (!this.state.application.agreeWithTerms) {
      newErrorMessages.push(
        "Πρέπει να συμφωνείτε με τους όρους για να υποβάλλετε τη δήλωση"
      )
      newErrors.agreeWithTerms = true
    }
    //saves errors in memory and returns false if there are errors
    if (newErrorMessages.length > 0) {
      this.setState({
        errorMessages: newErrorMessages,
        errors: newErrors
      })
    } else {
      this.setState({
        errorMessages: newErrorMessages,
        errors: newErrors,
        submitModalIsOpen: true
      })
    }
  }

  render() {
    const {
      dataIsLoading,
      application,
      perifereies,
      logoiMetathesis,
      theseisExoterikou,
      theseisEythinis,
      onlyAbroad
    } = this.state
    return (
      <div className="noprint">
        <Container
          textAlign="left"
          style={{ marginTop: "2em", marginBottom: "2em" }}>
          <Segment>
            <Grid verticalAlign="middle" stackable>
              <Grid.Column floated="left" width={13}>
                <Header size="large">
                  Δήλωση Επιθυμιών Μεταθέσεων {process.env.REACT_APP_YEAR}
                </Header>
              </Grid.Column>
              <Grid.Column floated="right" width={3}>
                {!this.state.formTouched && application.id ? (
                  <Label as="p" circular color="blue">
                    Προσωρινά αποθηκευμένη
                  </Label>
                ) : null}
              </Grid.Column>
            </Grid>
          </Segment>
          <TopMessage ama={application.ama} />
          <Grid stackable>
            <Grid.Column width={16}>
              <Segment>
                <Form
                  loading={dataIsLoading}
                  error={this.state.errorMessages.length > 0}
                  // onSubmit={this.handleDataChange}
                >
                  <RadioYesNo
                    name="epithymiaMetathesis"
                    label="Επιθυμώ μετάθεση"
                    value={application.epithymiaMetathesis}
                    onChange={this.handleChange}
                  />
                  {!onlyAbroad && (
                    <>
                      <RadioYesNo
                        label="Επιθυμώ μετάθεση σε μονάδα διετίας"
                        name="epithymiaDietias"
                        value={application.epithymiaDietias}
                        disabled={!application.epithymiaMetathesis}
                        onChange={this.handleChange}
                      />
                      <Positions
                        errors={this.state.errors}
                        perifereies={perifereies}
                        logoiMetathesis={logoiMetathesis}
                        onChange={this.handleDataChange}
                        clearValues={this.clearValues}
                        epithymiaMetathesis={application.epithymiaMetathesis}
                        selectedPerifereiaA={application.selectedPerifereiaA}
                        selectedDimosA={application.selectedDimosA}
                        selectedLogosA={application.selectedLogosA}
                        selectedPerifereiaB={application.selectedPerifereiaB}
                        selectedDimosB={application.selectedDimosB}
                        selectedLogosB={application.selectedLogosB}
                        selectedPerifereiaC={application.selectedPerifereiaC}
                        selectedDimosC={application.selectedDimosC}
                        selectedLogosC={application.selectedLogosC}
                      />
                      <Form.Checkbox
                        label="Αναφορά (επιθυμία συνυπηρέτησης, ένταξη σε κοινωνικά κριτήρια)"
                        name="anafora"
                        onChange={this.handleDataChange}
                        checked={application.anafora}
                      />
                    </>
                  )}
                  {/* {application.anafora ? (
                    <Form.Input
                      placeholder="Εισάγετε το λόγο αναφοράς. Μέγιστο 55 χαρακτήρες."
                      label="Λόγος"
                      name="logosAnaforas"
                      value={application.logosAnaforas || ""}
                      onChange={this.handleDataChange}
                      maxLength="55"
                    />
                  ) : null} */}
                  {!onlyAbroad && (
                    <>
                      {/* <Form.Checkbox
                        name="anaforaSynipiretisis"
                        label="Αναφορά επιθυμίας συνυπηρέτησης"
                        onChange={this.handleDataChange}
                        checked={application.anaforaSynipiretisis}
                      /> */}
                      {/* <Form.Group>
                        <Form.Field>
                          Οικογενειακή Κατάσταση: όπως έχει δηλωθεί <br />
                          (Για οποιαδήποτε μεταβολή να αποστέλλονται τα
                          απαιτούμενα δικαιολογητικά στο ΓΕΑ/Β1/1μ
                        </Form.Field>
                      </Form.Group> */}
                    </>
                  )}

                  <Form.Field>
                    {onlyAbroad && (
                      <Header size="tiny">Επιθυμία μετάθεσης εξωτερικού</Header>
                    )}
                    {onlyAbroad && (
                      <Dropdown
                        disabled={
                          !application.epithymiaMetathesis && onlyAbroad
                        }
                        name="epithymiesExoterikou"
                        value={application.epithymiesExoterikou}
                        placeholder="Επιλέξτε θέσεις"
                        multiple
                        selection
                        options={theseisExoterikou}
                        onChange={this.handleDataChange}
                      />
                    )}
                  </Form.Field>

                  <CommandPositions
                    //disabled={!application.epithymiaMetathesis && !onlyAbroad}
                    options={theseisEythinis}
                    valueA={application.thesiEythinisA}
                    valueB={application.thesiEythinisB}
                    valueC={application.thesiEythinisC}
                    onChange={this.handleChange}
                    //disabled={!application.epithymiaMetathesis}
                  />

                  <Form.Field error={this.state.errors.agreeWithTerms}>
                    <Form.Checkbox
                      error={this.state.errors.agreeWithTerms}
                      name="agreeWithTerms"
                      onChange={this.handleDataChange}
                      checked={application.agreeWithTerms}
                      label="Με την υποβολή της δήλωσης:"
                    />
                    <ApplicationBullets ama={application.ama} />
                  </Form.Field>

                  <Message
                    error
                    header="Παρακαλώ ελέγξτε τα παρακάτω:"
                    list={this.state.errorMessages}
                  />
                  <br />
                  <br />
                  <ApplicationActions
                    validate={this.validateForm}
                    save={this.saveApplication}
                  />
                </Form>
              </Segment>
            </Grid.Column>
          </Grid>
        </Container>
        <SaveModal
          submitModalIsOpen={this.state.submitModalIsOpen}
          toggleSubmitModal={this.toggleSubmitModal}
          saveApplication={this.saveApplication}
          finalSave={this.finalSave}
        />
      </div>
    )
  }
}

export default withRouter(ApplicationForm)
